import Amplify from "aws-amplify";
import { cognitoConfig } from "../config/cognitoConfig"

export function getCallbackUrl(location = window.location) {
  return `${location.origin}/`;
}

export function initializeAmplify(stage="DEV", region="us-west-2") {
  const callbackUrl = getCallbackUrl();
  const oauth = {
    domain: cognitoConfig[stage][region]["domain"],
    scope: ['openid'],
    redirectSignIn: callbackUrl,
    redirectSignOut: callbackUrl,
    responseType: 'code'
  };

  Amplify.configure({
    Auth: {
      userPoolId: cognitoConfig[stage][region]["userPoolId"],
      userPoolWebClientId: cognitoConfig[stage][region]["userPoolWebClientId"],
      mandatorySignIn: true,
      region: region,
      oauth: oauth
    }
  });
}
